import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./DisplayContactAMDialog.module.css";

const DisplayContactAMDialog = ({ open, onClose, amDetails = [] }) => {
  const contactLabel = amDetails.length === 1 ? "Contact" : "Contacts";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h6" component="span" sx={{ flexGrow: 1 }}>
          Account Manager {contactLabel}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className={styles.dialogContent}>
        <Box
          className={styles.tableContainer}
          sx={{
            maxHeight: 300,
            overflowY: "auto",
          }}
        >
          <Table size="small" className={styles.tableRoot}>
            <TableHead>
              <TableRow>
                <TableCell
                  className={styles.tableHeaderCell}
                  sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}
                >
                  Name
                </TableCell>
                <TableCell
                  className={styles.tableHeaderCell}
                  sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}
                >
                  Email
                </TableCell>
                <TableCell
                  className={styles.tableHeaderCell}
                  sx={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}
                >
                  Product Category
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {amDetails.length > 0 ? (
                amDetails.map((am, index) => (
                  <TableRow key={index}>
                    <TableCell>{am.name || "N/A"}</TableCell>
                    <TableCell>
                      {am.email ? (
                        <a href={`mailto:${am.email}`} className={styles.mailLink}>
                          {am.email}
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                    <TableCell
                      sx={{
                        maxWidth: 300,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.5,
                        }}
                      >
                        {am?.labels?.length > 0 ? (
                          am.labels.map((label, index) => (
                            <Box
                              key={index}
                              sx={{
                                backgroundColor: "#e3f2fd",
                                color: "#1565c0",
                                padding: "3px 10px",
                                borderRadius: "12px",
                                fontSize: "12px",
                                fontWeight: 500,
                                maxWidth: 250,
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                            >
                              {label}
                            </Box>
                          ))
                        ) : (
                          "N/A"
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center" className={styles.noDataCell}>
                    No account manager details available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DisplayContactAMDialog;
